import React from 'react'
import appConfig from './src/config'
import * as Sentry from '@sentry/browser'
import AppRoot from './src/AppRoot'
// @ts-ignore
import pkg from './package.json'
//
// if (appConfig?.sentry?.enabled) {
Sentry.init({
  dsn: appConfig?.sentry?.dsn,
  environment: appConfig?.sentry?.environment,
  release: pkg.version,
  // debug: true,
  tracesSampleRate: 1.0,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
  // enableAutoSessionTracking: true,
  // sessionTrackingIntervalMillis: 100,
  // enableAutoPerformanceTracking: true,
  // enableNdkScopeSync: true,
  // enableNative: true,
  // enableInExpoDevelopment:
  //   appConfig?.BUILD_ENV === 'development'
})
// }

export default function App() {
  return <AppRoot />
}
